import { useEffect, useState } from "react";
import { ListDetailTemplate, OneList } from "../../styles/common";
import theme from "../../styles/theme";
import styled from "styled-components";
import { TextField } from "@mui/material";
import CounterDetail from "./CounterDetail";
import CounterKeyDetail from "./CounterKeyDetail";

const Counter = ({mode, ccid, carsDetail}) => {

    const [counters, setCounters] = useState();
    const [countersKey, setCountersKey] = useState();

    const [counterIndex, setCounterIndex] = useState(0);

    useEffect(()=>{
        if(carsDetail){
            setCounters(carsDetail.counters);
        }
    },[carsDetail])


    useEffect(()=>{
        counters && counters.length > 0 ? setCounterIndex(counters[0].cnt_no) : setCounterIndex();
    },[counters, carsDetail])

    useEffect(()=>{
        counterIndex ? setCountersKey(carsDetail.countersKey.filter((item)=>item.cnt_no === counterIndex)) : setCountersKey();
    },[counterIndex, carsDetail])

    return (
        <ListDetailTemplate style={{border:'0'}}>
            <CounterDetail mode={mode} ccid={ccid} counters={counters} onClick={setCounterIndex} />
            <CounterKeyDetail mode={mode} cnt_no={counterIndex} countersKey={countersKey} />
        </ListDetailTemplate>
    )

}

const CounterKeyItemWrap = styled.div`
    display: grid;
    grid-template-columns: 1rem 2rem 6rem 14rem;
    align-items: center;
    font-size: 1rem;
    border-bottom: 1px solid ${theme.color.black[20]};
    .textfield{
        margin: 0.25rem 0;
    }

`;

const CounterKeyItem = ({index, item}) => {

    const [keyVal, setKeyVal] = useState();

    useEffect(()=>{
        setKeyVal((item && item.code)?{key:String.fromCharCode(item.code),code:item.code}:{key:'',code:''});
    },[item])

    return (
        <CounterKeyItemWrap>
            <span />
            <span>{index}</span>
            <span>{item.car_tm}</span>
            <div className="textfield">
                <TextField
                    id='snm'
                    size="small"
                    style={{width:'6rem'}} 
                    value={keyVal && keyVal.key}
                    InputLabelProps={{shrink:true}}
                    onKeyDown={(e)=>setKeyVal({key:e.key, code:e.keyCode})}
                />
            </div>
        </CounterKeyItemWrap>
    )
}

export default Counter;